export const iconFontAwesomeHumanitarianTents = (
	<i className="fa-solid fa-tents"></i>
);
